import React from 'react';
import { MessageCircle, ShoppingCart, TrendingUp, DollarSign, Bot, User } from 'lucide-react';

function SalesAnalytics({ analytics }) {
  const stats = [
    {
      label: 'Chats Activos',
      value: analytics.chats.active_24h,
      icon: MessageCircle,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Bot Manejando',
      value: analytics.chats.bot_handled,
      icon: Bot,
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      label: 'Humano Manejando',
      value: analytics.chats.human_handled,
      icon: User,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      label: 'Órdenes',
      value: analytics.orders.confirmed,
      icon: ShoppingCart,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    },
    {
      label: 'Conversión',
      value: `${analytics.orders.conversion_rate}%`,
      icon: TrendingUp,
      color: 'text-pink-600',
      bgColor: 'bg-pink-50'
    },
    {
      label: 'Revenue',
      value: `S/${analytics.revenue.total.toFixed(0)}`,
      icon: DollarSign,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50'
    }
  ];

  return (
    <div className="px-6 py-4 bg-gradient-to-r from-purple-50 to-pink-50 border-t border-gray-200">
      <div className="grid grid-cols-6 gap-4">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-lg p-3 shadow-sm">
            <div className="flex items-center justify-between">
              <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                <stat.icon className={`w-4 h-4 ${stat.color}`} />
              </div>
              <span className="text-xl font-bold text-gray-900">
                {stat.value}
              </span>
            </div>
            <p className="text-xs text-gray-600 mt-2">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SalesAnalytics;